import api from '../../api/mas-athena';

const state = {
    rooms: {},
    selectedRoom: {}
};

const getters = {
    allRooms: state => state.rooms,
    selectedRoom: state => state.selectedRoom
};

const actions = {
    async fetchRooms({ commit }, data) {
        const response = await api.fetchRooms(data['start_date'], data['end_date']);

        commit('setRooms', response.data);
    },
    async fetchRoom({ commit }, room_id) {
        const response = await api.fetchRoom(room_id);

        commit('setRoom', response.data.results);
    }    
};

const mutations = {
    setRooms: (state, rooms) => {
        state.rooms = rooms
    },
    setRoom: (state, room) => {
        state.selectedRoom = room
    }    
};

export default {
    state,
    getters,
    actions,
    mutations
}